var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-5.0 -10.0 110.0 135.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m68.75 20.832c4.7969 0 9.5977 1.832 13.258 5.4922 7.3203 7.3203 7.3203 19.195 0 26.516l-32.008 30.492-32.008-30.492c-7.3203-7.3203-7.3203-19.195 0-26.516 3.6602-3.6602 8.4609-5.4922 13.258-5.4922 2.0977 0 4.1992 0.35156 6.2031 1.0508 3.3516 1.1719 6.2344 3.3945 8.4258 6.1875l4.1211 5.2617 4.1211-5.2617c2.1875-2.793 5.0742-5.0156 8.4258-6.1875 2.0039-0.69922 4.1016-1.0508 6.2031-1.0508m0-4.1641c-2.5898 0-5.1406 0.43359-7.5781 1.2852-3.9766 1.3906-7.5469 4-10.328 7.5508l-0.84375 1.0742-0.84375-1.0742c-2.7812-3.5508-6.3516-6.1602-10.328-7.5508-2.4375-0.85156-4.9883-1.2852-7.5781-1.2852-6.1211 0-11.875 2.3828-16.203 6.7109-8.9336 8.9336-8.9336 23.473 0 32.41l32.078 30.562c0.80469 0.76563 1.8398 1.1484 2.875 1.1484s2.0703-0.38281 2.875-1.1484l32.008-30.492c9.0078-9.0078 9.0078-23.543 0.070313-32.48-4.3281-4.3281-10.082-6.7109-16.203-6.7109z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarWhite);
export default __webpack_public_path__ + "static/media/StarWhite.33629b6c6e78ee9f65338b0cf6fc5e01.svg";
export { ForwardRef as ReactComponent };